<template>
  <div ref="main">
    <user-input
      ref="userInput"
      :search-options="searchOptions"
      :modal-active="modalActive"
      :placeholder="placeholder"
      @focus="onInputFocus"
      @change="onInputFocus"
      @enter-keyword="onSelect"
      @current-input="updateCurrentInput"
    />
    <dropdown-modal
      :width="modalWidth"
      :active="modalActive"
      :userInput="currentInput"
      @select-keyword="onSelect"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import UserInput from './UserInput';
import DropdownModal from './DropdownModal';

export default {
  components: {
    UserInput,
    DropdownModal,
  },
  props: {
    searchOptions: {
      type: Object,
      default: () => {},
    },
    placeholder: {
      default: () => this.$t('find.INPUT_TEXT'),
    },
  },
  data() {
    return {
      modalWidth: null,
      modalActive: false,
      currentInput: '',
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.modalWidth = `${this.$refs.userInput.$el.clientWidth}px`;
    });
  },
  watch: {
    modalActive() {
      this.modalWidth = `${this.$refs.userInput.$el.clientWidth}px`;
    },
  },
  computed: {
    ...mapState('stocksAutocompleteSearch', {
      keywords: state => state.selectedKeywords,
    }),
  },
  methods: {
    onInputFocus() {
      this.modalActive = true;
      this.startSearch = true;
      document.addEventListener('click', this.checkOutFocus);
    },
    onSelect() {
      this.modalActive = false;
      this.$emit('keywords-change', this.keywords);
      document.removeEventListener('click', this.checkOutFocus);
      this.clearCurrentInput();
    },
    checkOutFocus(evt) {
      if (!this.$refs.main || !this.$refs.main.contains(evt.target)) {
        this.modalActive = false;
        document.removeEventListener('click', this.checkOutFocus);
      }
    },
    updateCurrentInput(val) {
      this.currentInput = val;
      this.modalActive = true;
      this.$emit('keyword-input', val);
    },
    clearCurrentInput() {
      this.currentInput = '';
    },
  },
};
</script>

<style scoped>
.hr {
  position: relative;
  z-index: 559;
  height: 1px;
  background: #000000;
  margin: 0 16px;
}
</style>
